import React from 'react';
import { Modal } from 'plataforma-fundacao-componentes';
import './ModalTimeoutChat.scss';

const rootClassName = 'modal-timeout-chat';

interface ModalTimeoutChatProps extends React.ComponentProps<typeof Modal> {
  message?: string;
  messageWithout?: string;
}

export default function ModalTimeoutChat(props: ModalTimeoutChatProps) {
  return (
    <Modal {...props}>
      {props.children!}
      {props.message && props.messageWithout ? (
        <div className={`${rootClassName}-atual-message-without nunito`}>
          {props.messageWithout}
        </div>
      ) : undefined}
      {props.message ? (
        <div className={`${rootClassName}-atual-message nunito`}>
          {props.message}
        </div>
      ) : undefined}
    </Modal>
  );
}
